module.exports = "/images/small-search-icon.svg?9d23d98cd728717a663471387c332794";